"use client";

import React from "react";
import { Building2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { CompanyContacts } from "@/features/contacts/components/CompanyContacts";
import { CompanyDetailsTab } from "@/components/shared/detail-tabs/CompanyDetailsTab";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { ActivityWithCompany } from "@/src/types/extended-entities";
import type { Communications } from "@/src/gql/graphql";

/**
 * Communications Company Display Tab Component
 */
export function CommunicationsCompanyDisplay({ item }: TabContentProps<Communications>) {
  const communicationWithCompany = item as unknown as ActivityWithCompany;

  if (!communicationWithCompany.company_name && !communicationWithCompany.company_id) {
    return (
      <Card>
        <CardContent>
          <div className="text-center py-8 text-gray-500">
            <Building2 className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>No company associated with this communication</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="w-full space-y-4">
      <CompanyDetailsTab embedded={false} />

      <CompanyContacts
        companyName={communicationWithCompany.company_name || "Unknown Company"}
        currentContactId=""
        currentContact={undefined}
      />
    </div>
  );
}
